import {
  convertMagnifiedToDecimal,
  magnifyValue,
  STOCK_UI,
} from '@diamond/shared/decimal-util-web';
import { Cart } from '@diamond/shared/types';
import { isEven } from '@diamond/shared/utils';

export interface CartItemStockInfo {
  orderQtyMultiple: number;
  minOrderQty: number;
  productStock: number;
  productCartQty: number;
  maxStockGanjil: number;
  maxStockGenap: number;
  isEmptyStock: boolean;
}

export const getCartItemStockInfo = (item: Cart): CartItemStockInfo => {
  const orderQtyMultiple = convertMagnifiedToDecimal(
    item?.product.order_quantity_multiple,
    STOCK_UI
  );

  const minOrderQty = convertMagnifiedToDecimal(
    item?.product.minimum_order_quantity,
    STOCK_UI
  );

  const productStock = convertMagnifiedToDecimal(item?.product.stock, STOCK_UI);
  const productCartQty = convertMagnifiedToDecimal(item?.quantity, STOCK_UI);

  const maxStockGanjil =
    Math.floor(productStock / orderQtyMultiple) * orderQtyMultiple;

  const maxStockGenap =
    Math.round(productStock / orderQtyMultiple) * orderQtyMultiple;

  const isEmptyStock =
    minOrderQty > productStock || item.product.stock_status === 'OUT_OF_STOCK';

  return {
    orderQtyMultiple,
    minOrderQty,
    productStock,
    productCartQty,
    maxStockGanjil,
    maxStockGenap,
    isEmptyStock,
  };
};

export const formatCartItemNote = (note: string | null | undefined): string => {
  return note || '';
};

export const validateCartItemQuantity = (
  quantity: number,
  stockInfo: CartItemStockInfo
): boolean => {
  const { minOrderQty, productStock, orderQtyMultiple } = stockInfo;

  return (
    quantity >= minOrderQty &&
    quantity <= productStock &&
    quantity % orderQtyMultiple === 0
  );
};
